// extracted by mini-css-extract-plugin
export default {"container":"UserItem_container__LxPIc"};